import React, { useRef, useState } from 'react'
import MDButton from 'components/MDButton';
import { Backdrop, CircularProgress, Modal } from '@mui/material';
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import { updateDepartmentInfo } from 'api/routes';
import urltoFile from './../../components/urlToFile';
import { addDepartmentLogo } from 'api/routes';
import { toast } from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'fit-content',
};
export default function GeneralInfo({ data }) {
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    const [address, setAddress] = useState()
    const [tel, setTel] = useState();
    const [isImageUpload, setIsImageUpload] = useState(false)
    const [workTime, setWorkTime] = useState();
    const [loading, setLoading] = useState(false);
    const handleOpenLoading = () => {
        setLoading(true);
    };
    const handleCloseLoading = () => {
        setLoading(false);
    };
    const editInfo = () => {
        setAddress(data[0].AddressDep)
        setTel(data[0].TelDep)
        setWorkTime(data[0].workingTime)
        handleOpen()
    }
    const updateInfo = () => {
        const data = {
            address,
            tel,
            workingTime: workTime
        }
        handleOpenLoading()
        handleClose()
        updateDepartmentInfo(data, (isOk, data) => {
            if (!isOk) {
                handleCloseLoading()
                return toast.error(data.message)
            }

            else {
                if (sessionStorage.getItem('logoimage') !== null) {
                    urltoFile(sessionStorage.getItem('logoimage'), 'file.jpeg', 'image/jpeg')
                        .then(function (file) {
                            const formData = new FormData();
                            formData.append("logo", new File([file], "file.jpeg", { type: "text/json;charset=utf-8" }));
                            addDepartmentLogo(formData, (isOk, data) => {
                                if (!isOk) {
                                    handleCloseLoading()
                                    return toast.error(data.message)
                                }
                                else {
                                    sessionStorage.removeItem('logoimage');
                                    return window.location.reload();
                                }
                            })
                        })
                } else return window.location.reload();
            }
        })
    }

    const file = useRef(null);


    const uploadImage = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            if (event.target.files[0].size / 1024 / 1024 < 6) {
                const reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = (event) => {
                    sessionStorage.setItem("logoimage", event.target.result);
                    setIsImageUpload(true)
                };
            } else toast.error("حجم فایل باید کمتر از 6 مگابایت باشد");
        }
    }
    return (

        <div style={{ padding: '1rem' }}>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>نام مرکز : </p>
                <p>{data[0].NameFa}</p>
            </section>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>آدرس مرکز : </p>
                <p>{data[0].AddressDep}</p>
            </section>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>تلفن مرکز : </p>
                <p>{data[0].TelDep}</p>
            </section>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>ساعت کاری مرکز : </p>
                <p>{data[0].workingTime}</p>
            </section>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>لوگو:</p>
                {data && data[0].logo && <img src={`data:image/jpeg;base64,${data[0].logo}`} alt='logo' style={{ objectFit: 'contain', width: '200px' }} />}
            </section>

            <MDButton onClick={editInfo} variant="gradient" color="info" sx={{ width: '120px', marginTop: '2rem' }}>
                ویرایش
            </MDButton>
            <Modal open={open} onClose={handleClose}>
                <MDBox sx={style}>
                    <MDInput multiline type="text" label="آدرس" value={address} onChange={(event) => setAddress(event.target.value)} fullWidth />
                    <MDInput type="text" value={tel} onChange={(event) => setTel(event.target.value)} label="تلفن" fullWidth sx={{ marginTop: '1rem' }} />
                    <MDInput type="text" value={workTime} onChange={(event) => setWorkTime(event.target.value)} label="ساعت کاری" fullWidth sx={{ marginTop: '1rem' }} />
                    <input ref={file} type="file" accept="image/*" style={{ display: 'none' }} onChange={uploadImage} />
                    <div style={{ borderRadius: '8px', display: 'flex', marginTop: '1rem', padding: '0 1rem', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #d2d6da', height: '56px' }} onClick={() => file?.current?.click()}>
                        <p style={{ color: '#00000099', fontSize: '1rem' }}>لوگو</p>
                        {isImageUpload ? <p style={{ color: 'rgb(74 222 128)', fontSize: '1rem' }}>آپلود شد</p> : <p style={{ color: '#00000099', fontSize: '1rem' }}>آپلود کنید</p>}
                    </div>
                    <MDButton onClick={updateInfo} variant="gradient" color="info" sx={{ width: '120px', marginTop: '2rem' }}>
                        تایید
                    </MDButton>
                </MDBox>
            </Modal>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}
